import { client } from "api";

export type GetSignatureRequest = { approvalId: string };
export type GetSignatureResponse = { id: string; imgUrl: string };

export const getSignature = ({ approvalId }: GetSignatureRequest) =>
  client
    .get<Blob>(`/approve/customersignature/${approvalId}`, {
      responseType: "blob",
    })
    .then((res) => ({
      id: approvalId,
      imgUrl: window.URL.createObjectURL(res.data),
    }));
